// Cuprite JS

// Purchase option toggle
function selectOpt(el, price) {
  document.querySelectorAll('.pc-opt').forEach(o => o.classList.remove('active'));
  el.classList.add('active');
  const priceEl = document.querySelector('.pc-price');
  if (priceEl) priceEl.textContent = price;
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  });
});
